import * as config from './../config/config'
import api from './interceptor'

export async function get_ListeAppartenance(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_APPARTENANCE);
    return response.data;
  } catch (error) {
    throw error;
  }
};